/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "theme-ui"
import { Select, Label } from "@theme-ui/components"
import { useState } from "react"
import { Switch } from "@headlessui/react"
import { getPrice } from "@lib/swell/storefront-data-hooks/src/utils/product"

function classNames(...classes: any[]) {
  return classes.filter(Boolean).join(" ")
}

export interface ToggleProps {
  options?: Readonly<Array<string | undefined>>
  onChange: any
  selected: boolean
  optionValue: any
}

const Toggle: React.FC<ToggleProps> = ({ onChange, selected, optionValue }) => {
  const { name, description } = optionValue

  return (
    <Switch.Group as="div" className="flex items-center justify-between">
      <span className="grow flex flex-col">
        <Switch.Label as="span" className="text-sm font-medium text-gray-900" passive>
          {name}
          {/* <span className="text-gray-500 text-xs">
            {optionValue.price ? ` ${getPrice(optionValue.price, "usd")}` : <></>}
          </span> */}
        </Switch.Label>
        <Switch.Description as="span" className="text-sm text-gray-500">
          {description}
        </Switch.Description>
      </span>
      {/* @ts-ignore */}
      <Switch
        checked={selected}
        onChange={onChange}
        className={classNames(
          selected ? "bg-primary-600" : "bg-gray-200",
          "relative inline-flex shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
        )}
      >
        <span
          aria-hidden="true"
          className={classNames(
            selected ? "translate-x-5" : "translate-x-0",
            "pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow-sm transform ring-0 transition ease-in-out duration-200"
          )}
        />
      </Switch>
    </Switch.Group>
  )
}

export default Toggle
